import styled from "styled-components";
import { Link } from "react-router-dom";
import { FiMail } from "react-icons/fi";

export const Nav = styled.nav`
  background-color: #1b1b1b;
  height: 80px;
  //margin-top: -80px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1rem;
  position: sticky;
  top: 0;
  z-index: 2;

  @media screen and (max-width: 960px) {
    transition: 0.8s all ease;
  }
`;

export const NavbarContainer = styled.nav`
  display: flex;
  justify-content: space-between;
  height: 80px;
  width: 100%;
  padding: 0 24px;
  max-width: 1800px;
`;

export const NavLogo = styled(Link)`
  color: #fefefa;
  justify-self: flex-start;
  cursor: pointer;
  font-size: 1.5rem;
  display: flex;
  align-items: center;
  margin-left: 24px;
  font-weight: bold;
  text-decoration: none;
`;

export const MobileIcon = styled.div`
  display: none;

  @media screen and (max-width: 912px) {
    display: block;
    position: absolute;
    top: 0;
    right: 0;
    transform: translate(-100%, 60%);
    font-size: 1.8rem;
    cursor: pointer;
    color: #fff;
  }
`;

export const NavMenu = styled.ul`
  display: flex;

  align-items: center;
  list-style: none;
  text-align: center;
  margin-right: -22px;

  @media screen and (max-width: 912px) {
    display: none;
  }
`;

export const NavItem = styled.li`
  height: 80px;
`;

export const NavLinks = styled(Link)`
  color: #f5f5f5;
  display: flex;
  align-items: center;
  text-decoration: none;
  padding: 0 1rem;
  height: 100%;
  cursor: pointer;

  &active {
    border-bottom: 3px solid #fefefa;
  }
  &:hover {
    transition: all 0.2s ease-in-out;
    color: #96a9fe;
    font-size: 1.01rem;
  }
`;

export const NavBtn = styled.nav`
  display: flex;
  align-items: center;

  @media screen and (max-width: 912px) {
    display: none;
  }
`;

export const NavBtnLink = styled(Link)`
  font-size: 1.2rem;
  font-weight: bold;
  padding: 0.7rem 1.5rem;

  border-radius: 5px;
  background-color: #96a9fe;
  white-space: nowrap;

  color: #fefefa;

  outline: none;
  border: none;
  cursor: pointer;

  transition: all 0.2s ease-in-out;
  text-decoration: none;

  &:hover {
    transition: all 0.2s ease-in-out;
    background-color: #ffb400;
  }
`;

export const MailIcon = styled(FiMail)`
  margin-right: 10px;
  color: #fefefa;
  font-size: 1.2rem;
`;


export const NavBarBtnContainer = styled.div`
display: flex;
align-items: center;

`;

export const NavLangBtnCol = styled.div`
display: flex;
height: auto;
flex-direction: column;
margin-left:5px;
@media screen and (max-width: 912px) {
    display:none;
  }

`;


export const NavBtnLang = styled.button`
cursor: pointer;
background-color: transparent;
border: none;
white-space: nowrap;
padding:3px;


`;

export const LangImg = styled.img`
display: flex;
align-items:center;
width: 27px;
border-radius: 5px;
opacity: 0.6;

-o-object-fit: fill;
object-fit: fill;
&:hover {
    transition: all 0.2s ease-in-out;
    opacity:1;
  }
`;